<template>
    <DocsKycForm 
        :sender_id="null"
        :first_name="sender.first_name || ''"
        :last_name="sender.last_name || ''"
        :middle_name="sender.middle_name || ''"
        :email="sender.email || ''"
        :phone="sender.phone || ''"
        :files="[]"
        />
</template>

<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import CameraForm from '@/components/personal/verification/camera_form.vue'
import DocsKycForm from '@/components/personal/verification/docs_kyc_form.vue'

export default {
    name: 'SenderAdd',
    data() {
        return {
            sender_id: null,
            sender: {}
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        screen_size() { return this.$store.getters.StateScreenSize },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        
        userPhone: function () { return this.$store.getters.StateUserPhone },
        userPrefix: function () { return this.$store.getters.StateUserPrefix },
        userPhoneNumber() { 
            if(!this.userPhone || !this.userPrefix) return null
            return `${this.userPrefix}${this.userPhone}` 
        },
        userEmail() { return this.$store.getters.StateUserEmail },
        userName() { return this.$store.getters.StateUserName },
    },
    methods: {
        
    },
    components: {
        CameraForm,
        DocsKycForm
    },
    beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)

        try {
            if(this.userPhoneNumber) {
                this.sender.phone = this.userPhoneNumber
            }
            if(this.userEmail) {
                this.sender.email = this.userEmail
            }
            if(this.userName) {
                const nameParts = this.userName.split(' ')
                if(nameParts.length>0) this.sender.first_name = nameParts[0]
                if(nameParts.length>1) this.sender.last_name = nameParts[1]
                if(nameParts.length>2) this.sender.middle_name = nameParts.slice(2).join(' ')
            }
        } catch (e) {
            console.error('Error pre-filling sender data:', e)
        }
    }
}
</script>